export enum BIDealOperationType {

    Open = "Open",
    Update = "Update",
    Close = "Close"
}
